import * as React from "react"

import Nav from '../components/Nav'
import Footer from '../components/Footer'
import Typewriter from 'typewriter-effect';

import homepageTopBG from "../images/home-page-top-bg.jpg"
import solutionsBG from "../images/solutions-bg.jpeg"
import technologyBG from "../images/technology-bg.jpeg"

import icon_idea from "../svg/icons/startup/017-lightbulb.svg"
import icon_cloud from "../svg/icons/startup/017-startup.svg"
import icon_resource from "../svg/icons/startup/017-analytics-1.svg"

import logo_aws from "../images/brands/aws.png"
import logo_ubuntu from "../images/brands/ubuntu.png"
import logo_postgres from "../images/brands/PostgreSQL.png"
import logo_node from "../images/brands/nodejs.png"
import logo_react from "../images/brands/React.png"
import logo_android from "../images/brands/620ccca75dacefc86b744731acad6474.png"

const IndexPage = () => {
  React.useEffect(() => {

  }, [])

  return (
    <React.Fragment>
      <Nav />
      <section id="header" className="py-0 overflow-hidden text-white">
        <div className="row g-0">
          <div className="col-lg-6 text-center text-lg-end overflow-hidden z-index-2 bg-gradient-dark">
            <div className="py-7 my-lg-7 px-3 px-lg-5">
              <h1 className="display-1 fw-bold mb-0">
                <span className="d-block">We are</span>
                <span className="d-block text-primary">
                  <Typewriter
                      options={{
                        strings: ['GalaSoftware', 'Technology', 'Software', 'Passion'],
                        autoStart: true,
                        loop: true,
                      }}
                  />
                </span>
              </h1>
              <p className="lead w-75 d-inline-block my-5">
                Il vostro business è importante, per questo mettiamo la nostra passione al servizio delle vostre esigenze.<br />
              </p>
              <div className="clearfix">
                <a href="#foot" className="d-inline-block text-white text-dashed border-primary py-2 fw-bold">
                  Entra in contatto con noi
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-6 bg-cover py-8 overlay overlay-opacity-25" style={{backgroundImage: `url(${homepageTopBG})`}}>
            <svg className="d-none d-lg-block position-absolute h-100 top-0 text-white ms-n7" style={{width: '12rem'}} viewBox="0 0 100 100" preserveAspectRatio="none">
              <defs>
                <linearGradient id="header-shape-gradient" x2="0" y2="1">
                  <stop offset="0%" stop-color="#253a6c" />
                  <stop offset="100%" stop-color="#1b2a4e" />
                </linearGradient>
              </defs>
              <polygon fill="url(#header-shape-gradient)" points="50,0 100,0 50,100 0,100" />
            </svg>
          </div>
        </div>
      </section>
      <section className="bg-gray-200">
        <div className="container-fluid">
          <div className="position-relative mx-lg-8">
            <div className="bg-dark rounded px-4 py-5 py-lg-8 position-relative z-index-1">
              <div className="container">
                <div className="mb-7 text-center">
                  <span className="d-inline-grid gap-auto-2 text-white">
                      <span>Soluzioni integrate</span>
                      <svg className="transform-flip-x-rtl" height="18px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </span>
                  <h2 className="h1 text-white">
                    Dalle idee alla tecnologia accessibile a tutti.
                  </h2>
                </div>
                <div className="row gy-5 gx-lg-5">
                  <div className="col-12 col-xl-4 position-relative">
                    <div className="card h-100 shadow-xs-primary transition-top-hover z-index-1">
                      <div className="card-header p-4 pb-0 d-flex align-items-center">
                        <img width={40} height={40} src={icon_idea} alt="..." />
                        <div className="col ps-4">
                          <h3 className="h5">
                            <a href="#!" className="text-decoration-none link-dark stretched-link">Ideazione software</a>
                          </h3>
                        </div>
                      </div>
                      <div className="card-body p-4">
                        <p className="mb-0">La tecnologia al servizio di tutti</p>
                      </div>
                    </div>
                    {/* dots pattern */}
                    <div className="bg-dots text-gray-400 position-absolute bottom-0 start-0 mb-n4 z-index-0 opacity-25" style={{width: '150px', height: '150px'}} />
                  </div>
                  <div className="col-12 col-xl-4 position-relative">
                    <div className="card h-100 shadow-xs-primary transition-top-hover z-index-1">
                      <div className="card-header p-4 pb-0 d-flex align-items-center">
                        <img width={40} height={40} src={icon_cloud} alt="..." />
                        <div className="col ps-4">
                          <h3 className="h5">
                            <a href="#!" className="text-decoration-none link-dark stretched-link">Cloud service</a>
                          </h3>
                        </div>
                      </div>
                      <div className="card-body p-4">
                        <p className="mb-0">Le nostre soluzioni in rete</p>
                      </div>
                    </div>
                    {/* dots pattern */}
                    <div className="bg-dots text-gray-400 position-absolute bottom-0 start-0 mb-n4 z-index-0 opacity-25" style={{width: '150px', height: '150px'}} />
                  </div>
                  <div className="col-12 col-xl-4 position-relative">
                    <div className="card h-100 shadow-xs-primary transition-top-hover z-index-1">
                      <div className="card-header p-4 pb-0 d-flex align-items-center">
                        <img width={40} height={40} src={icon_resource} alt="..." />
                        <div className="col ps-4">
                          <h3 className="h5">
                            <a href="#!" className="text-decoration-none link-dark stretched-link">Monitoraggio performance</a>
                          </h3>
                        </div>
                      </div>
                      <div className="card-body p-4">
                        <p className="mb-0">Soluzioni in continuo miglioramento</p>
                      </div>
                    </div>
                    {/* dots pattern */}
                    <div className="bg-dots text-gray-400 position-absolute bottom-0 start-0 mb-n4 z-index-0 opacity-25" style={{width: '150px', height: '150px'}} />
                  </div>
                </div>
              </div>
            </div>
            {/* dots pattern */}
            <div className="bg-dots text-gray-400 position-absolute bottom-0 start-0 mb-n4 ms-n4 z-index-0 w-100 h-100" />
          </div>
        </div>
        <div className="container">
          {/* brands */}
          <div className="col-10 offset-1 col-lg-8 offset-lg-2 text-center mt-8">
            <div id="brands" className="row justify-content-center">
              <div className="col-4 col-sm-2 py-2 py-sm-3">
                <img src={logo_aws} alt="Amazon Web Services" />
              </div>
              <div className="col-4 col-sm-2 py-2 py-sm-3">
                <img src={logo_ubuntu} alt="Ubuntu server" />
              </div>
              <div className="col-4 col-sm-2 py-2 py-sm-3">
                <img src={logo_postgres} alt="PSQL" />
              </div>
              <div className="col-4 col-sm-2 py-2 py-sm-3">
                <img src={logo_android} alt="Android" />
              </div>
              <div className="col-4 col-sm-2 py-2 py-sm-3">
                <img src={logo_node} alt="NodeJS" />
              </div>
              <div className="col-4 col-sm-2 py-2 py-sm-3">
                <img src={logo_react} alt="ReactJS" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* infos */}
      <section>
        <div className="container">
          <div className="row g-4 g-lg-5 align-items-center">
            <div className="col-12 col-lg-6 mb-5">
              <div className="mb-5">{/* section : title */}
                <span className="d-inline-grid gap-auto-2 text-primary">
                    <span>Soluzioni</span>
                    <svg className="transform-flip-x-rtl" height="18px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </span>
                <h2 className="h1">
                  Soluzioni su <span className="text-primary">Misura</span>
                </h2>
              </div>
              <p className="lead">Cerchiamo sempre di dividere il progetto complessivo in moduli più piccoli da realizzare in step successivi, dando così al cliente dei risultati tangibili e verificabili in minor tempo e consentendo un miglior controllo di ciò che stiamo realizzando, senza perdere comunque la visione complessiva dell’intero progetto</p>
            </div>
            <div className="col-12 col-lg-6 mb-5">
              <div className="card bg-cover overlay overlay-opacity-5 overflow-hidden jarallax d-flex align-items-center justify-content-center" style={{height: '350px', backgroundImage: `url(${solutionsBG})`}} />
            </div>
          </div>
        </div>
      </section>
      {/* infos */}
      <section className="bg-gray-200">
        <div className="container">
          <div className="row g-4 g-lg-5 align-items-center">
            <div className="col-12 col-lg-6 mb-5">
              <div className="card bg-cover overlay overlay-opacity-5 overflow-hidden jarallax d-flex align-items-center justify-content-center" style={{height: '350px', backgroundImage: `url(${technologyBG})`}} />
            </div>
            <div className="col-12 col-lg-6 mb-5">
              <div className="mb-5">{/* section : title */}
                <span className="d-inline-grid gap-auto-2 text-primary">
                    <span>Innovazione tecnologica</span>
                    <svg className="transform-flip-x-rtl" height="18px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </span>
                <h2 className="h1">
                  Migliorare la <span className="text-primary">produttività</span>
                </h2>
              </div>
              <p className="lead">Gala Software sviluppa e integra software per l'informatizzazione aziendale, la comunicazione e l'editoria elettronica. Soluzioni integrate per ottimizzare le procedure gestionali di PMI e pubblica amministrazione basate sulle migliori tecnologie, database distribuiti, applicazioni intranet/web oriented e applicazioni multimediali per la promozione di attività.</p>
            </div>
          </div>
        </div>
      </section>
      <div className="divider-point-bl bg-gray-200" />
      <Footer />
    </React.Fragment>
  )
}

export default IndexPage
